import {useContext, useState, useEffect} from "react";
import { motion } from "framer-motion";
import { dataContext } from "../../../context/context";
import './cases.css';
import MainCard from "./mainCard";
import CasesCardDesktop from "./casesCardDesktop";


function CasesGaleryDesktop() {

    const { data, loading, error, isBY, isRU, isLocal   } = useContext(dataContext);
    const [imageIndex, setImageIndex] = useState(0);
    const [showItems, setShowItems] = useState(false);


        const section = data.sectionsdata.find(s => s.nick === 'cases');
        const paragraph = section ? section.paragraphsdata.find(p => p.nick === 'cases1') : [];
        const galerydata = paragraph.galerydata;

    useEffect(() => {
        const interval = setInterval(() => {
            setImageIndex((prev) => prev >= galerydata.length - 1  ? 0 : prev + 1);
        }, 7000);

        return () => clearInterval(interval);
    }, [imageIndex]);



        return (

            <>
                { galerydata.length > 0 && (
             <>
            <>

                <MainCard selection={imageIndex} onIndexChange = {i => setImageIndex(i)} />

            </>

                 <>
                 {

                 <motion.div className="otherCards" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true, amount: 0.25 }} transition={{ duration: 0.1 }} onAnimationComplete={() => {
                     setShowItems(true);
                 }} >

                {

                    galerydata.map((gal, index) => (

                        <motion.div initial={{ opacity: 0, rotateY: 360 }} animate={ showItems ? { opacity: 1, rotateY: 0 } : {}} transition={{ delay: index * 0.5, duration: 0.5 }} className={index === imageIndex ? 'galery-main__carddesktop galery-main__carddesktopactive' : 'galery-main__carddesktop galery-main__carddesktopnotactive'} key={index} onClick={() => setImageIndex(index)}>
                          <CasesCardDesktop key={index} index={index} />
                        </motion.div>

                    ))

                }

                </motion.div>

                 }
                     </>


            </>
                    )
                }

            </>
        )


    }

export default CasesGaleryDesktop;